import { memo } from "react";
import { useSelector } from "react-redux";

import { TableRow } from "@mui/material";

import { EditLineButton } from "components/utility/EditLineButton";

import { LineItem } from "views/Builds/Build/Output/LineItem";

// Memoized row component to prevent unnecessary re-renders
const MemoizedLineItem = memo(
  ({
    line,
    index,
    objectType,
    record,
    bins,
    classes,
    classesCount,
    location,
    lineHandler,
    items,
    itemsCount,
    addItem,
    jobWorkcenters,
    lineItemsErrors,
    setLineEdit,
    lineReadOnly = false,
  }) => {
    const linesLoading = useSelector((state) => state.loading.linesLoading);
    return (
      <TableRow
        key={index}
        sx={{ position: "inherit", background: "none" }}
        isDragDisabled={linesLoading}
      >
        <EditLineButton
          onClick={setLineEdit}
          lineIndex={index}
          recordId={record?.id}
          lineReadOnly={lineReadOnly}
        />
        <LineItem
          objectType={objectType}
          record={record}
          bins={bins}
          classes={classes}
          classesCount={classesCount}
          location={location}
          line={line}
          lineHandler={lineHandler}
          items={items}
          itemsCount={itemsCount}
          addItem={addItem}
          jobWorkcenters={jobWorkcenters}
          lineItemsErrors={lineItemsErrors}
          lineReadOnly={lineReadOnly}
        />
      </TableRow>
    );
  },
  (prevProps, nextProps) => {
    // Custom comparison to prevent unnecessary re-renders
    return (
      prevProps.line === nextProps.line &&
      prevProps.index === nextProps.index &&
      prevProps.lineItemsErrors === nextProps.lineItemsErrors &&
      prevProps.items === nextProps.items &&
      prevProps.classes === nextProps.classes &&
      prevProps.jobWorkcenters === nextProps.jobWorkcenters &&
      prevProps.location === nextProps.location &&
      prevProps.bins === nextProps.bins &&
      prevProps.record.workcenter === nextProps.record.workcenter &&
      prevProps.record.autoSerialLotNumbering ===
        nextProps.record.autoSerialLotNumbering &&
      prevProps.lineReadOnly === nextProps.lineReadOnly &&
      prevProps.setLineEdit === nextProps.setLineEdit
    );
  }
);

// helps React DevTools and error messages show a readable name
MemoizedLineItem.displayName = "MemoizedLineItem";

export { MemoizedLineItem };
